<template>
  <!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
  <screen-container direction="column" :no-header="true" class="screen-no-access">
    <div class="screen-no-access__number">400</div>
    <div class="screen-no-access__title">
      {{ $t('errors.400.title') }}
    </div>
    <div class="screen-no-access__description">
      {{ $t('errors.400.description') }}
    </div>
    <div class="screen-no-access__actions">
      <a :href="`${URLS.SSO}/?app_version=2&redirect=/&sign_out=1`">
        {{ label }}
      </a>
    </div>
  </screen-container>
</template>

<script>
import ScreenContainer from '@/components/Screen/Container.vue'
import { URLS } from '@/config/urls.config'

export default {
  name: 'ScreenError',
  components: {
    ScreenContainer,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    URLS,
  }),
}
</script>

<style lang="scss" scoped>
.screen-no-access {
  align-items: center;
  justify-content: center;

  &__number {
    line-height: 1;
    font-size: 6rem;
    font-weight: 700;

    @media (min-width: $screen-sm) {
      font-size: 10rem;
    }
  }

  &__title {
    text-align: center;
    font-size: 2rem;
    font-weight: 600;

    @media (min-width: $screen-sm) {
      font-size: 3rem;
    }
  }

  &__description {
    text-align: center;
    font-size: $font-size-md;
  }

  &__title,
  &__description,
  &__actions {
    margin-top: $gutter-tablet;

    @media (min-width: $screen-xl) {
      margin-top: $gutter-desktop;
    }
  }
}
</style>
